import moment from 'moment'
import { PaymentMethod, PaymentTerm, TaskDto, TaskStatus } from '../../../../definition'
import { employeeLabel, preventMouseEvent } from '../../../../utils'
import { ModalNodeProps } from '../../../components/modal.component'
import html2canvas from 'html2canvas'
import { Col, Row } from 'antd'
import { getPaymentMethodlabel } from '../../../../utils'
import { SWITCH_FUNCTION } from '../../../../constants'
import TextArea from 'antd/lib/input/TextArea'
import { renderAddress } from '../../../../utils/booking-util'

export const TechnicianReport = (props: ModalNodeProps<TaskDto>) => {
  const selectedTimeSlot = `
  ${moment(props.input?.timeSlotBeginAt).format('HH:mm')}-
  ${moment(props.input?.timeSlotEndAt).format('HH:mm')}`

  const print = async () => {
    const printBtn = document.getElementById('print-technician-report')
    const closeBtn = document.getElementsByClassName('app-modal-header-close')?.[0] as HTMLElement

    // const paymentMethods = document.querySelectorAll('.payment-method>div');
    // const paymentMethodSelected = document.querySelectorAll(
    //   '.payment-method>div.selected',
    // );

    printBtn && (printBtn.style.display = 'none')
    closeBtn && (closeBtn.style.display = 'none')
    // for (const item of paymentMethods || [])
    //   (item as HTMLElement).style.display = 'none';
    // for (const item of paymentMethodSelected || [])
    //   (item as HTMLElement).style.display = 'flex';

    try {
      const overlayElement = document.querySelector('.technician-report')?.closest('.overlay') as HTMLElement
      const root = overlayElement?.closest('#root') as HTMLElement
      const canvas = await html2canvas(document.body)
      canvas.style.position = 'absolute'
      canvas.style.top = '0'
      root.appendChild(canvas)
      window.print()
      root.removeChild(canvas)
    } catch (error) {
      console.log('print error :', error)
    }
    printBtn && (printBtn.style.display = 'flex')
    closeBtn && (closeBtn.style.display = 'flex')
    // paymentMethods &&
    //   paymentMethods.forEach(
    //     (item) => ((item as HTMLElement).style.display = 'flex'),
    //   );
  }

  console.log(props.input)

  return (
    <div className='technician-report'>
      <div className='left'>
        <label>Job Detail</label>
        <div className='job-detail'>
          <div className='item'>
            <label>Customer Name</label>
            <span>{props.input?.account?.profile?.name}</span>
          </div>
          <div className='item'>
            <label>Booking No</label>
            <span>{props.input?.booking?.code}</span>
          </div>
          <div className='item status'>
            <label>Status</label>
            <div>Completed</div>
          </div>
          <div className='item'>
            <label>Contact Number</label>
            <div>{props.input?.account?.profile?.contact}</div>
          </div>
          <div className='item'>
            <label>Email</label>
            <div>{props.input?.account?.email}</div>
          </div>
          <div className='item'></div>

          <div className='item'>
            <label>Address</label>
            <div>
              <span>
                {renderAddress([props.input?.address1, props.input?.address2, props.input?.city, props.input?.country])}
              </span>
              <div>{props.input?.unitNo}</div>
            </div>
          </div>

          <div className='item'>
            <label>Postal Code</label>
            <div>{props.input?.postalCode}</div>
          </div>
        </div>

        <Row>
          <Col span={16}>
            <label>Type of Service</label>
            <div className='service-info'>
              {props.input?.services?.length ? (
                <>
                  {props.input?.services?.map((service) => (
                    <div>{service.name}</div>
                  ))}
                </>
              ) : (
                <div>{props.input?.service?.name}</div>
              )}
            </div>
          </Col>
          {!SWITCH_FUNCTION.tech_not_collect && (
            <Col span={8}>
              <div className='label-input'>
                <label>Payment Method</label>
                {props.input?.booking?.paymentTerm === PaymentTerm.CREDIT ? (
                  <p>Not collected by {employeeLabel()} due to credit terms</p>
                ) : (
                  <div className='paymentMethod'>
                    {getPaymentMethodlabel(props.input?.booking?.invoice?.paymentMethod)}
                  </div>
                )}
              </div>
            </Col>
          )}
        </Row>

        <Row>
          <Col span={16}>
            <label>Added VO</label>
            <div className='service-info'>
              {(props.input?.booking?.invoice?.voInvoices?.length || 0) > 0
                ? props.input?.booking?.invoice?.voInvoices
                    ?.map((voInvoice) => voInvoice.voServices?.map((voS) => voS.service?.name).join(', '))
                    .join(', ')
                : 'No VO added'}
            </div>
          </Col>
          {!SWITCH_FUNCTION.tech_not_collect && (
            <Col span={8}>
              {props.input?.booking?.invoice?.voInvoices?.[0] && (
                <div className='label-input'>
                  <label>VO Payment Method</label>
                  {props.input?.booking?.paymentTerm === PaymentTerm.CREDIT ? (
                    <p>Not collected by {employeeLabel()} due to credit terms</p>
                  ) : (
                    <div className='paymentMethod'>
                      {getPaymentMethodlabel(props.input?.booking?.invoice?.voInvoices?.[0]?.paymentMethod)}
                    </div>
                  )}
                </div>
              )}
            </Col>
          )}
        </Row>

        <label>{employeeLabel({ isFirstLetterUp: true })} Remark</label>
        <div className='technician-remark'>{props.input?.assigneeRemark}</div>
        <div id='print-technician-report' className='print' onClick={preventMouseEvent(print)}>
          Print Job Completion Report
        </div>
      </div>
      <div className='right'>
        <label>Assigned Employee</label>
        <div className='technician-info'>{props.input?.assignee?.profile?.name}</div>

        <div className='time-info'>
          <div className='time-item'>
            <label>Appointment Date</label>
            <div>{moment(props.input?.timeSlotBeginAt).format('DD MMM YYYY')}</div>
          </div>

          <div className='time-item'>
            <label>Time slot</label>
            <div>{selectedTimeSlot}</div>
          </div>
        </div>

        <label>Attachment upload by {employeeLabel()}</label>
        <div className='images'>
          {(props.input?.images || []).map((item, index) => (
            <a href={item} target={'_blank'} rel='noreferrer'>
              <img src={item} key={index} alt='task images' />
            </a>
          ))}
        </div>

        <div className='signature-info'>
          <div className='signature-item'>
            <label>Customer Sign</label>
            <img src={props.input?.accountSignUrl} alt='customer signature' />
          </div>

          <div className='signature-item'>
            <label>Assigned Sign</label>
            <img src={props.input?.assigneeSignUrl} alt='technician signature' />
          </div>
        </div>
        {props.input?.siteAccessIssue && (
          <div>
            <label>Site Access Issue Description</label>
            <TextArea className='site-access' value={props.input?.siteAccessIssue} rows={8}></TextArea>
          </div>
        )}
        <div className='completed-time'>
          <label>Time Started</label>
          <div>
            {props.input?.statusHistory[TaskStatus.STARTED]
              ? moment(props.input?.statusHistory[TaskStatus.STARTED]).format('MMMM Do YYYY, hh:mmA')
              : ''}
          </div>
        </div>
        <div className='completed-time'>
          <label>Time Completed</label>
          <div>
            {props.input?.timeCompleted ? moment(props.input?.timeCompleted).format('MMMM Do YYYY, hh:mmA') : ''}
          </div>
        </div>
      </div>
    </div>
  )
}
